module.exports = __webpack_public_path__ + "img/aedd9c3.jpg";